import { Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const GroupAvatar = ({ children, chatName, small }) => {
  const initials = chatName
      .match(/\b(\w)/g)
      ?.join('')
      ?.toUpperCase()
      .slice(0, 2),
    { t } = useTranslation();

  chatName = chatName ? t('messages.newChat') : chatName;

  return (
    <Row
      bg={theme.ORANGE}
      ht={small ? '40px' : '72px'}
      wid={small ? '40px' : '72px'}
      hasRadius="100px"
      centerAll
      noFlex
    >
      <Row noFlex>
        <Text h4 b2={small} bold col={'#000'}>
          {initials}
        </Text>
      </Row>

      {children}
    </Row>
  );
};

export default GroupAvatar;
